// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Permissions.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import PermissionBreadcrumb from './Izenda.PermissionBreadcrumb';
import PermissionBody from './Izenda.PermissionBody';
import actions from './Izenda.PermissionActions';
import PropTypes from 'prop-types';

@connect(actions)
export default class Permissions extends Component {
  static propTypes = {
    permissionStore: PropTypes.object.isRequired
  };

  componentDidMount() {
    const { props } = this;
    props.getCategoryAccessibility();
  }

  componentWillUnmount() {
    this.props.permissionStore.reset();
  }

  /**
   * render component
   * @return {Object} component
   */
  render() {
    const { roleDetail, permissionStore, accessStore, disabledTab, readOnly } = this.props;
    const isTemplatePermissions = roleDetail && roleDetail.isTemplateRole;

    return (
      <div className='u_fullHeight izenda-Permission'>
        <PermissionBreadcrumb permissionStore={permissionStore} disabledTab={disabledTab} />
        <PermissionBody
          isTemplatePermissions={isTemplatePermissions}
          permissionStore={permissionStore}
          disabledTab={disabledTab}
          accessStore={accessStore}
          readOnly={readOnly}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/Izenda.Permissions.jsx